import { mxConstants, mxRectangle, mxText } from 'mxgraph-js';
import HCLVertexState from '../HCLCellState/HCLVertexState';

abstract class HCLText extends mxText {
  protected constructor() {
    super();
    this.family = 'inherit';
    this.valign = 'bottom';
    this.color = 'inherit';
    this.dialect = mxConstants.DIALECT_STRICTHTML;
    this.spacing = 12;
    this.wrap = true;
  }

  /**
   * Return the value to draw
   * @param {HCLVertexState} state
   */
  abstract getValue(state: HCLVertexState): string;

  /**
   * Return the bounds to draw
   * @param {HCLVertexState} state
   */
  abstract getBounds(state: HCLVertexState): mxRectangle;

  /**
   * Update the value and bounds of the text
   * @param {HCLVertexState} state
   */
  update(state: HCLVertexState): void {
    this.state = state;
    this.scale = state.getCell().getGraph().getView().getScale();
    this.bounds = this.getBounds(state);
    this.value = this.getValue(state);
    this.redraw();
  }
}

export default HCLText;
